import { PhotoItemObject } from '@pages/gallery/PhotoItemObject';
import gallery01 from '@assets/images/gallery/gallery01.webp';
import gallery02 from '@assets/images/gallery/gallery02.webp';
import gallery03 from '@assets/images/gallery/gallery03.webp';
import gallery04 from '@assets/images/gallery/gallery04.webp';
import gallery05 from '@assets/images/gallery/gallery05.webp';
import gallery06 from '@assets/images/gallery/gallery06.webp';
import gallery07 from '@assets/images/gallery/gallery07.webp';
import gallery08 from '@assets/images/gallery/gallery08.webp';
import gallery09 from '@assets/images/gallery/gallery09.webp';
import gallery10 from '@assets/images/gallery/gallery10.webp';
import gallery11 from '@assets/images/gallery/gallery11.webp';
import gallery12 from '@assets/images/gallery/gallery12.webp';
import gallery13 from '@assets/images/gallery/gallery13.webp';
import gallery14 from '@assets/images/gallery/gallery14.webp';
import gallery15 from '@assets/images/gallery/gallery15.webp';



export const galleryItems: PhotoItemObject[] = [
	{
		image: gallery01,
		text: 'item01.text',
		name: 'item01.name',
	},
	{
		image: gallery02,
		text: 'item02.text',
		name: 'item02.name',
	},
	{
		image: gallery03,
		text: 'item03.text',
		name: 'item03.name',
	},
	{
		image: gallery04,
		text: 'item04.text',
		name: 'item04.name',
	},
	{
		image: gallery05,
		text: 'item05.text',
		name: 'item05.name',
	},
	{
		image: gallery06,
		text: 'item06.text',
		name: 'item06.name',
	},
	{
		image: gallery07,
		text: 'item07.text',
		name: 'item07.name',
	},
	{
		image: gallery08,
		text: 'item08.text',
		name: 'item08.name',
	},
	{
		image: gallery09,
		text: 'item09.text',
		name: 'item09.name',
	},
	{
		image: gallery10,
		text: 'item10.text',
		name: 'item10.name',
	},
	{
		image: gallery11,
		text: 'item11.text',
		name: 'item11.name',
	},
	{
		image: gallery12,
		text: 'item12.text',
		name: 'item12.name',
	},
	{
		image: gallery13,
		text: 'item13.text',
		name: 'item13.name',
	},
	{
		image: gallery14,
		text: 'item14.text',
		name: 'item14.name',
	},
	{
		image: gallery15,
		text: 'item15.text',
		name: 'item15.name',
	},
]